export default __webpack_public_path__ + "static/media/portfolio-197.919d5ccb.jpg";